import '@adornis/calendar/calendar.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ChromiumButton } from './cr-button.js';
import './cr-campus-loader.js';
import './cr-card.js';
import './cr-flex.js';
import './cr-icon.js';
import './cr-link.js';
import './fonts.js';

@customElement('cr-delete-button')
export class ChancenDeleteButton extends ChromiumButton {
  constructor() {
    super();

    this.mode = 'outline';
    this.icon = 'delete';
    this.tone = 'error';
  }

  override render() {
    return html`
      <cr-flex
        center
        crossaxis-center
        ${css({
          border: `1px solid ${this.colors.tone.error}`,
          borderRadius: this.sizes.borderRadius,
          padding: `${this.spacing.xs} ${this.spacing.sm}`,
        })}
      >
        <cr-icon ${css({ color: this.colors.tone.error })}>delete</cr-icon>
      </cr-flex>
    `;
  }
}
